export enum INVITE_STATE {
	INVITED = 'INVITED',
	ACCEPTED = 'ACCEPTED',
	DECLINED = 'DECLINED',
}
